import {ChangeDetectorRef, Component, forwardRef, Input, Optional} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUINumericControlComponent),
            multi: true
        }
    ],
    selector: "fui-numeric-control",
    templateUrl: "./numeric-control.component.html",
    standalone: false
})
export class FUINumericControlComponent extends FUIAbstractControl {
    @Input() decimals: number;
    @Input() showClear: boolean = false;
    /**
     * Indicates if the numeric control can be removed when in pill mode
     */
    @Input() public removable: boolean = true;

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
    }
}
